module.exports = __webpack_public_path__ + "img/1.d6bf0e1a.png";